import { DEDUCTIONS_PROVIDERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type PostDeductionsProvidersRequest = {
  employerIdNumber: string;
  deductionsIds: number[];
};

export type PostDeductionsProvidersResponse = {
  message?: string;
};

export const postDeductionsProviders = async (
  data: PostDeductionsProvidersRequest,
): Promise<PostDeductionsProvidersResponse> => {
  const response = await apiInstance.post<PostDeductionsProvidersResponse>(
    DEDUCTIONS_PROVIDERS,
    data,
  );
  return response.data;
};
